import { getChainById } from 'symbiosis-js-sdk'
import { VESISConfig } from '~/types/config'

export function getSISUrl(config: VESISConfig): string {
	const chain = getChainById(config.chain.id)

	return `https://app.symbiosis.finance/swap?chainIn=Ethereum&chainOut=${chain.name}&tokenIn=ETH&tokenOut=${config.sisAddress}`
}
